import * as React from "react";
import { Option } from "@stemscopes/ui";
import { virtualizedTypes } from "../../duck";

const ListItem: React.FC<{
  index: number;
  item: virtualizedTypes.ListItem;
  setSize: virtualizedTypes.SetSize;
  style: any;
}> = ({ item, index, setSize, style: { height, ...restStyle } }) => {
  const itemRef = React.useRef<HTMLDivElement | null>(null);

  const itemHeight = itemRef.current?.getBoundingClientRect().height;

  React.useEffect(() => {
    if (itemHeight) {
      setSize(index, itemHeight);
    }
  }, [itemHeight, index, setSize]);

  const onRefChangeCallback = React.useCallback(
    (node: { closest: (arg0: string) => HTMLDivElement | null }) => {
      if (node) {
        itemRef.current = node.closest("li");
      }
    },
    [],
  );

  return (
    <Option value={item.id} label={item.label} style={restStyle}>
      <span ref={onRefChangeCallback as React.Ref<HTMLSpanElement>}>
        {item.label}
      </span>
    </Option>
  );
};

export default ListItem;
